import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import BiddingsTableSC, { PaginationWrapSC, AdditionalTopSC } from './biddings-table.styled';
import { BodyText, SmallText } from '../typography';
import SecondaryMarketItem from './bidding-item';
import { ReactComponent as LeftArrow } from '../../assets/img/svg/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../assets/img/svg/right-arrow.svg';
import dlt from '../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../utils/screen-size';
import { BP_TABLET_MIN } from '../../assets/styles/breakpoints';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import WishmakerModal from '../ui/modal/modal';
import SmsVerification from '../sms-verification';
import SuccessModal from '../success-modal';
import BidModal from '../secondary-market-table/bid-modal';
import BuyModal from '../secondary-market-table/buy-modal';
import WarningModal from '../warning-modal';
import ErrorModal from '../error-modal';

const _BiddingsTable = ({
  maxRows,
  hasPagination,
  hasAdditionalTop,
  hasLinkOnAll,
  instruction,
  sendSms,
  buySecondaryMarketOffer,
  bidSecondaryMarketOffer,
  history,
  secondaryMarket,
  getInvestorBiddings,
  getInvestorSecondaryMarket,
  biddings,
  acceptBiddingOffer,
  declineBiddingOffer,
  getInvestorDashboardData,
}) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;
  const [additionalData, setAdditionalData] = useState({});
  const [isSmsModalOpened, setSmsModalOpened] = useState(false);
  const [isSuccessModalOpened, setSuccessModalOpened] = useState(false);
  const [formattedData, setFormattedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isBuyModalOpened, setIsBuyModalOpened] = useState(false);
  const [isWarnModalOpened, setWarnModalOpened] = useState(false);
  const [warnModalHeadline, setWarnModalHeadline] = useState('');
  const [isResourcesErrorModalOpened, setResourcesErrorModalOpened] = useState(false);

  const [isBidModalOpened, setIsBidModalOpened] = useState(false);
  const [offerDetail, setOfferDetail] = useState({});
  const [bidAmount, setBidAmount] = useState('');

  const itemsPerPage = 8;

  const fetch = useCallback(
    (page) => {
      const paginationData = {
        page: page || 1,
        per_page: itemsPerPage,
      };

      const onBadResponse = () => {
        console.log('error');
      };

      const onSuccess = () => {
        setIsLoading(false);
      };

      getInvestorBiddings({ data: paginationData, onSuccess, onBadResponse });
    },
    [getInvestorBiddings]
  );

  /* Call data on start */
  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    let formattedDataArray = [];
    if (maxRows) {
      formattedDataArray = biddings.items.slice(0, maxRows);
    } else {
      formattedDataArray = biddings.items;
    }
    setFormattedData(formattedDataArray);
  }, [maxRows, biddings]);

  /* Table pagination */
  const onArrowClick = (type) => {
    let formattedData = {
      per_page: itemsPerPage,
    };
    switch (type) {
      case 'next':
        formattedData = {
          page: (biddings.pagination.current_page += 1),
          ...formattedData,
        };
        break;
      case 'back':
        formattedData = {
          page: (biddings.pagination.current_page -= 1),
          ...formattedData,
        };
        break;
      default:
        break;
    }

    const onBadResponse = () => {
      setIsLoading(true);
      formattedData = {
        page: biddings.pagination.current_page,
        ...formattedData,
      };
      setTimeout(() => {
        sendTablePagination();
      }, 10000);
    };
    const onSuccess = () => {
      setIsLoading(false);
    };

    const sendTablePagination = async () => {
      await getInvestorBiddings({ data: formattedData, onSuccess, onBadResponse });
      setIsLoading(true);
    };
    sendTablePagination();
  };

  /* Send sms */
  const onSmsSend = (smsType) => {
    if (smsType) {
      sendSms({ type: smsType });
    } else {
      switch (additionalData.type) {
        case 'buy':
          sendSms({ type: 'buy' });

          break;
        case 'bid':
          sendSms(/* { type: 'bid-offer' } */);
          break;

        case 'cancel':
          sendSms(/* { type: 'bid-offer' } */);
          break;

        default:
          sendSms(/* { type: 'bid-offer' } */);
          break;
      }
    }
  };

  /* On buy offer click */
  const onBuyClick = (biddingId) => {
    setIsBuyModalOpened(false);
    setAdditionalData({ biddingId, type: 'buy' });
    onSmsSend('buy');
    setSmsModalOpened(true);
  };

  const onBidClick = (offerData) => {
    setOfferDetail(offerData);
    setIsBidModalOpened(true);
  };

  const onCancelClick = (offerData) => {
    setAdditionalData({ biddingId: offerData.bidding_id, type: 'cancel' });
    onSmsSend('cancel-bid');
    setSmsModalOpened(true);
  };

  const onBidModalSubmit = (offerId, biddingId, bidAmount) => {
    setBidAmount(bidAmount);
    setIsBidModalOpened(false);
    setAdditionalData({ offerId: offerId, biddingId: biddingId, type: 'bid' });
    onSmsSend('make-bid');
    setSmsModalOpened(true);
  };

  /* SMS Confirmation of cancel offer call */
  const onSmsModalSubmit = (smsModalData) => {
    const onBadSmsCode = () => {
      setIsSending(false);
      setIsSmsCodeError(true);
    };

    const onOfferError = (code) => {
      setIsSending(false);
      setSmsModalOpened(false);
      setIsBuyModalOpened(false);
      setWarnModalOpened(true);

      if (code === 'NOT_YOUR_TURN') {
        setWarnModalHeadline('investor_secondary_market_not_your_turn_error_headline');
      } else if (code === 'NOT_ENOUGH_FREE_RESOURCES') {
        setWarnModalHeadline('investor_secondary_market_offer_error_resources');
      } else {
        setWarnModalHeadline('investor_secondary_market_offer_closed_error_headline');
      }
    };

    const onResourcesError = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setIsBuyModalOpened(false);
      setResourcesErrorModalOpened(true);
    };

    const onSuccess = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setIsBuyModalOpened(false);
      setSuccessModalOpened(true);
    };

    const onError = () => {
      setIsSending(false);
    };

    if (smsModalData.type === 'buy') {
      const onBuyOffer = async () => {
        await acceptBiddingOffer({
          data: { sms_code: smsModalData.sms_code },
          bidding: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onBiddingError: onOfferError,
          onResourcesError,
          onError,
        });
        setIsSending(true);
      };
      onBuyOffer();
    }
    if (smsModalData.type === 'bid') {
      const onBidOffer = async () => {
        await bidSecondaryMarketOffer({
          data: {
            sms_code: smsModalData.sms_code,
            value: Number(bidAmount?.replace(/ /g, '').replace(/,/g, '.')),
          },
          offer: smsModalData.offerId,
          biddingId: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onOfferError,
          onError,
        });
        setIsSending(true);
      };
      onBidOffer();
    }
    if (smsModalData.type === 'cancel') {
      const onCancelOffer = async () => {
        await declineBiddingOffer({
          data: { sms_code: smsModalData.sms_code },
          bidding: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onBiddingError: onOfferError,
          onError,
        });
        setIsSending(true);
      };
      onCancelOffer();
    }
  };

  /* Call refreshed data after success call */
  const callRefreshedData = () => {
    fetch(biddings.pagination.current_page);
    getInvestorSecondaryMarket({
      data: {
        page: secondaryMarket.pagination.current_page,
        per_page: secondaryMarket.pagination.per_page,
      },
    });
  };

  /* After success modal close call refresh data */
  const onCloseSuccess = () => {
    setSuccessModalOpened(false);
    callRefreshedData();
  };

  const onWarnModalClose = () => {
    setWarnModalOpened(false);
    getInvestorSecondaryMarket({
      data: {
        page: secondaryMarket.pagination.current_page,
        per_page: secondaryMarket.pagination.per_page,
      },
    });
    getInvestorBiddings({
      data: {
        page: biddings.pagination.current_page,
        per_page: biddings.pagination.per_page,
      },
    });
    getInvestorDashboardData();
  };

  const onCloseResourcesErrorModal = () => {
    setResourcesErrorModalOpened(false);
    getInvestorSecondaryMarket({
      data: {
        page: secondaryMarket.pagination.current_page,
        per_page: secondaryMarket.pagination.per_page,
      },
    });
    getInvestorBiddings({
      data: {
        page: biddings.pagination.current_page,
        per_page: biddings.pagination.per_page,
      },
    });
    getInvestorDashboardData();
  };

  if (!formattedData.length) {
    return null;
  }

  return (
    <>
      <WishmakerModal
        isOpened={isSuccessModalOpened}
        onClose={() => onCloseSuccess()}
        className="special"
        withCross
      >
        <SuccessModal
          headlineText={
            additionalData.type === 'buy'
              ? 'investor_bidding_success_modal_buy'
              : additionalData.type === 'bid'
              ? 'investor_bidding_success_modal_bid'
              : 'investor_bidding_success_modal_cancel'
          }
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isWarnModalOpened}
        onClose={onWarnModalClose}
        className="special"
        withCross
      >
        <WarningModal headlineText={warnModalHeadline} />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isResourcesErrorModalOpened}
        onClose={onCloseResourcesErrorModal}
        className="special"
        withCross
      >
        <ErrorModal headlineText="investor_secondary_market_resources_error_headline" />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isBuyModalOpened}
        onClose={() => {
          setIsBuyModalOpened(false);
        }}
        className="special"
        withCross
      >
        <BuyModal
          type="biddings"
          offerDetail={offerDetail}
          onSubmit={(offerId, biddingId) => onBuyClick(biddingId)}
          instruction={instruction}
          isBiddingTable
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isSmsModalOpened}
        onClose={() => setSmsModalOpened(false)}
        className="special"
        withCross
      >
        <SmsVerification
          onSubmit={(data) => onSmsModalSubmit(data)}
          additionalData={additionalData}
          isError={isSmsCodeError}
          isSending={isSending}
          onResend={() => onSmsSend()}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isBidModalOpened}
        onClose={() => setIsBidModalOpened(false)}
        className="special"
        withCross
      >
        <BidModal
          secondOffer
          offerDetail={offerDetail}
          onSubmit={(offerId, biddingId, bidAmount) =>
            onBidModalSubmit(offerId, biddingId, bidAmount)
          }
          instruction={instruction}
          isBiddingTable
        />
      </WishmakerModal>

      {hasAdditionalTop ? (
        <AdditionalTopSC>
          <BodyText className="bolder">
            <FormattedMessage
              id="investor_bidding_table_headline"
              defaultMessage={dlt['investor_bidding_table_headline']}
            />
          </BodyText>
          <div className="line-separator"></div>
        </AdditionalTopSC>
      ) : null}
      <BiddingsTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_1"
                    defaultMessage={dlt['investor_bidding_table_head_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_2"
                    defaultMessage={dlt['investor_bidding_table_head_2']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_3"
                    defaultMessage={dlt['investor_bidding_table_head_3']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_4"
                    defaultMessage={dlt['investor_bidding_table_head_4']}
                  />
                </SmallText>
              </th>
              <th></th>
            </tr>
          </thead>
        )}

        <tbody>
          {formattedData.map((item) => {
            return (
              <SecondaryMarketItem
                key={item.bidding_id}
                wmNumber={item.wm_number}
                amountForSale={Number(item.amount_for_sale)}
                buyerLastBid={Number(item.buyer_last_bid)}
                sellerLastBid={Number(item.seller_last_bid)}
                showButtons={item.show_buttons}
                status={item.status}
                timeRemaining={item.time_remaining}
                isTablet={isTablet}
                onBuyClick={() => {
                  setOfferDetail({
                    ...item,
                    price: item.last_bidder === 'b' ? item.buyer_last_bid : item.seller_last_bid,
                  });
                  setIsBuyModalOpened(true);
                }}
                onBidClick={() => onBidClick(item)}
                onCancelClick={() => onCancelClick(item)}
                hasPagination={hasPagination}
                lastBidder={item.last_bidder}
              />
            );
          })}
        </tbody>
      </BiddingsTableSC>

      {hasPagination ? (
        <PaginationWrapSC>
          <BodyText className="bolder orange">
            {biddings.pagination.from}-{biddings.pagination.to}{' '}
            <FormattedMessage id="global_from" defaultMessage={dlt['global_from']} />{' '}
            {biddings.pagination.total}
          </BodyText>
          <div className="arrow-wrap">
            <button
              disabled={biddings.pagination.current_page < 2 || isLoading}
              onClick={() => onArrowClick('back')}
            >
              <LeftArrow />
            </button>
            <button
              disabled={
                biddings.pagination.current_page === biddings.pagination.last_page || isLoading
              }
              onClick={() => onArrowClick('next')}
            >
              <RightArrow />
            </button>
          </div>
        </PaginationWrapSC>
      ) : null}
    </>
  );
};

_BiddingsTable.propTypes = {
  maxRows: PropTypes.number,
  hasPagination: PropTypes.bool,
  hasAdditionalTop: PropTypes.bool,
};

_BiddingsTable.defaultProps = {
  maxRows: null,
  hasPagination: false,
  hasAdditionalTop: false,
};

const mapStateToProps = (state) => {
  return {
    biddings: state.biddings,
    instruction: state.instruction,
    secondaryMarket: state.secondary_market,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      getInvestorBiddings: ActionCreators.getInvestorBiddings,
      getInvestorSecondaryMarket: ActionCreators.getInvestorSecondaryMarket,
      buySecondaryMarketOffer: ActionCreators.buySecondaryMarketOffer,
      bidSecondaryMarketOffer: ActionCreators.bidSecondaryMarketOffer,
      acceptBiddingOffer: ActionCreators.acceptBiddingOffer,
      declineBiddingOffer: ActionCreators.declineBiddingOffer,
      getInvestorDashboardData: ActionCreators.getInvestorDashboardData,
    },
    dispatch
  );
};

const BiddingsTable = withRouter(connect(mapStateToProps, mapDispatchToProps)(_BiddingsTable));

export default BiddingsTable;
